/* eslint-disable jsx-a11y/img-redundant-alt */
import { useTranslation } from "react-i18next";
import "../styles/Aboutus.css";
import image1 from "../Images/gife/gife.png";
import image2 from "../Images/gife/photo2.png";
import { ArrowUpOutlined } from "@ant-design/icons";
import { animateScroll as scroll } from "react-scroll"; // Import the scroll function
import { Button } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const Gift = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const { t } = useTranslation();
  const scrollToTop = () => {
    scroll.scrollToTop(); // Scroll to the top of the page
  };
  const [showScrollButton, setShowScrollButton] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > window.innerHeight) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="ALL">
      <div className="Text-Top">
        <h1 className="Text-About">{t("GifeA")}</h1>
        <div>
          <img src={image1} alt="image" className="image1" />
        </div>

        <br />
        <div>
          <img src={image2} alt="image" className="image1" />
        </div>
      </div>
      {showScrollButton && (
        <Button
          type="primary"
          className="scroll-to-top-button"
          onClick={scrollToTop} // Add onClick handler for scrolling to top
        >
          <ArrowUpOutlined />
        </Button>
      )}
    </div>
  );
};

export default Gift;
